module.exports = {
    guillaume: {
        name: 'Guaillaume Launay',
        title: 'Managing Director',
        email: 'guillaume.launay@lunalogistik.com',
        phone: '+41 22 989 08 27',
        image: '/static/media/guillaume-launay-head-of-logistics-lunalogistik.700ace17.jpg'
    },
};